import { render, staticRenderFns } from "./OrganizationFooter.vue?vue&type=template&id=599103ca&scoped=true"
import script from "./OrganizationFooter.vue?vue&type=script&lang=js"
export * from "./OrganizationFooter.vue?vue&type=script&lang=js"
import style0 from "./OrganizationFooter.vue?vue&type=style&index=0&id=599103ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599103ca",
  null
  
)

export default component.exports